import React, { Component } from "react"

export default class Screenscrying extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Screen Scrying</p>
            <p className="portdesctext">Award winning entry to 45symbols competition for their seventh issue. Project entailed utilising data-ming and bioinformatics to eschew pandemic health science.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href = 'http://www.45symbols.com/symbols/portfolio/screen-scrying-ali-razzak/' target = "_blank" rel="noopener noreferrer"><p className="linktext">Site</p></a>
        </div>
      </div>
  )
}
}

